import { useState, useEffect, useCallback } from 'react'
import { apiUrl } from '@/lib/api'

interface Teacher {
  id: string
  displayName: string
  role: 'head_teacher' | 'assistant'
  classroomId: string
}

interface AuthState {
  teacher: Teacher | null
  isLoading: boolean
  isAuthenticated: boolean
}

export function useAuth(): AuthState & { logout: () => Promise<void>; refresh: () => Promise<void> } {
  const [state, setState] = useState<AuthState>({
    teacher: null,
    isLoading: true,
    isAuthenticated: false,
  })

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(apiUrl('/api/auth/me'), { credentials: 'include' })
      const data = await res.json()
      if (data.authenticated) {
        setState({
          teacher: data.teacher,
          isLoading: false,
          isAuthenticated: true,
        })
      } else {
        setState({ teacher: null, isLoading: false, isAuthenticated: false })
      }
    } catch {
      setState({ teacher: null, isLoading: false, isAuthenticated: false })
    }
  }, [])

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  const logout = useCallback(async () => {
    await fetch(apiUrl('/api/auth/logout'), { method: 'POST', credentials: 'include' })
    setState({ teacher: null, isLoading: false, isAuthenticated: false })
  }, [])

  const refresh = useCallback(async () => {
    await fetch(apiUrl('/api/auth/refresh'), { method: 'POST', credentials: 'include' })
  }, [])

  return { ...state, logout, refresh }
}
